import { logger } from '@/lib/client'
import { TrackingUserSchema } from '@/schemas/tracking.user'
import type { z } from 'zod'
import posthog from './analytics/posthog'

export const SignIn = async (
  properties: z.infer<typeof TrackingUserSchema>,
): Promise<void> => {
  const event = 'Login'

  try {
    if (TrackingUserSchema.parse(properties)) {
      posthog.identify(properties)
    }
  } catch (error) {
    logger(
      'TRACKING LOGIN',
      JSON.stringify({
        event: event,
        name: error?.name,
        message: error?.message,
      }),
    )
  }
}

export const SignUp = async (
  properties: z.infer<typeof TrackingUserSchema>,
): Promise<void> => {
  const event = 'Cadastro'

  try {
    if (TrackingUserSchema.parse(properties)) {
      posthog.identify(properties)
    }
  } catch (error) {
    logger(
      'TRACKING Cadastro',
      JSON.stringify({
        event: event,
        name: error?.name,
        message: error?.message,
      }),
    )
  }
}
